import { Component } from '@angular/core';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.scss']
})
export class SuccessStoriesComponent {
cards=[
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/download (1).jpeg',
    name:'Ali',
    rank:'instructor'
  },
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur  adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/download (2).jpeg',
    name:'Ali',
    rank:'instructor'
  },
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/images.jpeg',
    name:'Ali',
    rank:'instructor'
  },
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/download.jpeg',
    name:'Ali',
    rank:'instructor'
  },
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/download (1).jpeg',
    name:'Ali',
    rank:'instructor'
  },
  {
    coment: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos quasi nulla voluptates voluptatum fuga!',
    img:'../../assets/download (2).jpeg',
    name:'Ali',
    rank:'instructor'
  },

]
}
